import { makeExecutableSchema } from '@graphql-tools/schema'
import type { GraphQLSchema } from 'graphql'

// NOTE: This is temporal. The schema will not live here.
// I'm just keeping this for now until we define how the
// frontend is going to get the schema.
const schema: GraphQLSchema = makeExecutableSchema({
  typeDefs: `
  scalar DateTime

  enum Product {
    analyze
    engage
    publish
  }

  enum Role {
    admin
    member
  }

  type Account {
    id: ID!
    email: String
    createdAt: DateTime
    featureFlips: [String]
    organizations: [AccountOrganization!]!
    products: [ProductLink]
    isImpersonation: Boolean!
    currentOrganization: AccountOrganization
  }

  type AccountOrganization {
    id: ID!
    name: String!
    role: Role!
    billing: Billing!
    canEdit: Boolean!
    createdAt: DateTime
    channelLimit: Int!
    channels(product: Product): [Channel]!
    isOneBufferOrganization: Boolean!
    featureFlips: [String]
  }

  type ProductLink {
    name: Product!
    userId: ID
  }

  type Billing {
    canAccessAnalytics: Boolean,
    canAccessEngagement: Boolean,
    canAccessPublishing: Boolean,
    paymentDetails: PaymentDetails,
    billingRedirectUrl: String
  }

  type PaymentDetails {
    hasPaymentDetails: Boolean
  }

  type EngageOrganization {
    id: String
    channels: [EngageChannel]
    emojis: [String]
  }

  type EngageChannel {
    id: String
    totalComments: Int
    totalPendingComments: Int
    labelsCount: [LabelCount]
    backfillingComplete: Boolean
    updatedAt: DateTime
  }

  type Channel {
    id: ID!
    name: String
    avatar: String
    service: String
    serviceId: String
    organizationId: String
    isDisconnected: Boolean
  }

  type EngagePost {
    id: String
    organizationId: String
    channelService: String
    channelServiceId: String
    createdAt: DateTime
    updatedAt: DateTime
    commentsUpdatedAt: DateTime
    deleted: Boolean
    backfilling: Boolean
    isGiveaway: Boolean
    dismissingAll: Boolean
    text: String
    mediaUrl: String
    permalink: String
    totalLikes: Int
    totalComments: Int
    totalPendingComments: Int
    comments: [Comment]
    labelsCount: [LabelCount]
  }

  type From {
    username: String
    isChannel: Boolean
  }

  type Attachment {
    type: String
    url: String
  }

  type Comment {
    id: String
    text: String
    createdAt: DateTime
    from: From
    replies: [Reply]
    needsAttention: Boolean
    error: Error
    labels: [String]
    status: String
    attachment: Attachment
  }

  type Reply {
    id: String
    text: String
    createdAt: DateTime
    from: From
    needsAttention: Boolean
    error: Error
    labels: [String]
    status: String
    attachment: Attachment
  }

  type UserSettings {
    showMarkAsReadWarningModal: Boolean
  }

  input UserSettingsInput {
    showMarkAsReadWarningModal: Boolean
  }

  type Error {
    type: String
    draft: String
    code: String
  }

  type EngagementMutationResponse {
    code: String
    success: Boolean
    message: String
    engagedWithId: String!
    post: EngagePost
    comment: Comment
    reply: Reply
    replySent: Reply
    channel: EngageChannel
  }

  type Counters {
    totalPendingComments: Int
    totalComments: Int
    labelsCount: [LabelCount]
  }

  type LabelCount {
    label: String
    count: Int
  }

  type CommonMutationResponse {
    code: String!
    success: Boolean!
    message: String!
  }

  type PusherAuth {
    auth: String
  }

  type ConnectedNode {
    node: EngagePost
    cursor: String
  }

  type PageInfo {
    endCursor: String
    hasNextPage: Boolean
  }

  type PaginatedPostResponse {
    edges: [ConnectedNode]
    pageInfo: PageInfo
  }

  input PostsFilter {
    by: String
    value: String
  }

  type Query {
    account: Account
    engageOrganization(organizationId: String): EngageOrganization
    engagePosts(
      organizationId: String!,
      channelService: String!,
      channelServiceId: String!,
      first: Int,
      after: String,
      filter: PostsFilter
    ): PaginatedPostResponse
    engagePost(id: String!, refreshMedia: Boolean): EngagePost
    engageUserSettings: UserSettings
    engagePusherAuthentication(socketId: String!, pusherChannel: String!): PusherAuth
  }

  type Mutation {
    engageReply(postId: String!, commentId: String!, text: String!): EngagementMutationResponse
    engageDismiss(postId: String!, commentId: String!): EngagementMutationResponse
    engageUnDismiss(postId: String!, commentId: String!): EngagementMutationResponse
    engageHideMarkAsReadModal: CommonMutationResponse,
    engageDismissAll(type: String!, targetId: String!): EngagementMutationResponse
  }
`,
})

export default schema
